import { useQuery } from '@apollo/client';
import * as _ from 'lodash-es';
import React from 'react';
import * as styles from './TopicActivitiesPanel.module.scss';
import Activities from '../activities/Activities';
import RightPanel from '../app/layout/RightPanel';
import EmptyState from '../components/EmptyState';
import { gql } from '../graphql/generated/gql';
import CreatePostButton from '../post/CreatePostButton';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';
import useSlug from '../utils/router/useSlug';

const TOPIC_ACTIVITIES_QUERY = gql(/** @complexity 125 */ `
  query topicActivities($id: ID!, $afterCursor: String) {
    topic(id: $id) {
      id
      activities(first: 10, after: $afterCursor) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Activities_activities
          }
        }
      }
    }
  }
`);

const TopicActivitiesPanel = () => {
  const [topicId] = useSlug('topicSlug');

  const response = useQuery(TOPIC_ACTIVITIES_QUERY, {
    variables: { id: topicId },
  });

  const fetchMore = ConnectionHelper.generateFetchMore(
    TOPIC_ACTIVITIES_QUERY,
    response,
    'topic.activities',
  );

  const topic = response.data?.topic;
  const activities = topic?.activities
    ? _.compact(topic.activities.edges?.map((edge) => edge?.node))
    : [];

  return (
    <RightPanel.Inner header="Activity">
      <div className={styles.content}>
        {activities.length > 0 ? (
          <Activities activities={activities} fetchMore={fetchMore} />
        ) : (
          <EmptyState
            title="No activity yet…"
            message="Activity will appear after a post has been created under this topic."
            action={
              <CreatePostButton
                size="large"
                variant="secondary"
                topicId={topicId}
              >
                Create a post
              </CreatePostButton>
            }
            vertical
          />
        )}
      </div>
    </RightPanel.Inner>
  );
};

export default TopicActivitiesPanel;
